import { render, staticRenderFns } from "./PaymentBalanceRule.vue?vue&type=template&id=71c3fd39&"
import script from "./PaymentBalanceRule.vue?vue&type=script&lang=js&"
export * from "./PaymentBalanceRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports